<template>
  <div class="personal-info">
    <div class="title">个人信息</div>
    <div class="form">
      <div class="form-line">
        <div class="form-left">头像：</div>
        <div class="form-right">
          <el-upload
            class="avatar-uploader"
            action=""
            :on-change="handleChange"
            :show-file-list="false"
            :http-request="uploadAvatar"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="form.avatar" :src="$url.cdn(form.avatar)" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">昵称：</div>
        <div class="form-right">
          <el-input v-model="form.nickname" placeholder="请输入昵称"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">性别：</div>
        <div class="form-right">
          <el-radio-group v-model="form.gender">
            <el-radio :label="2">女</el-radio>
            <el-radio :label="1">男</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">身份证号：</div>
        <div class="form-right">
          <el-input v-model="form.id_card" placeholder="请输入身份证号"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">绑定邮箱：</div>
        <div class="form-right">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left"><span>*</span>绑定手机号：</div>
        <div class="form-right">
          <el-input v-model="form.mobile" readonly placeholder="请输入手机号"></el-input>
          <div class="bdyx" @click="editPhone">换绑</div>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">微信：</div>
        <div class="form-right">
          <el-input v-model="form.weixin" placeholder="请输入微信"></el-input>
        </div>
      </div>
    </div>
    <div class="bottom-button">
      <div class="red-button" @click="saveInfo">保存资料</div>
      <div class="red-button" @click="resetInfo">重置信息</div>
    </div>
    <el-dialog
      title="换绑手机号"
      :visible.sync="editEoP"
      width="480px"
    >
      <el-form>
        <div class="form-line">
          <div class="form-left">新手机号：</div>
          <div class="form-right">
            <el-input v-model="ToastText" placeholder="请输入新手机号"></el-input>
          </div>
        </div>
        <div class="form-line">
          <div class="form-left">验证码：</div>
          <div class="form-right">
            <el-input v-model="code" placeholder="请输入验证码"></el-input>
            <div class="bdyx codeWidth" :class="disabled ? 'disabled' : ''" @click="getCode">
              {{ btntxt }}
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" style="display: flex;justify-content: center;" class="dialog-footer">
        <el-button class="red-button" @click="editEoP = false">取 消</el-button>
        <el-button class="red-button" @click="submitChange">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
import {mapGetters} from "vuex";
import appApi from '@/api/app';
import userApi from '@/api/user';
import { fileUpload } from "@/units/upload";
export default {
  data() {
    return {
      imageUrl: "",
      form: {
        avatar: '',
        nickname: '',
        gender: 1,
        id_card: '',
        email: '',
        mobile: '',
        weixin: ''
      },
      editEoP: false,
      ToastText: "",
      code: "",
      disabled: false,
      time: 60,
      btntxt: "发送验证码",
      file: null
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.$emit("getCompontsIndex", 0);
    this.getUserInfo();
  },
  methods: {
    // 上传文件，获取文件流
    handleChange(file) {
      this.file = file.raw;
    },
    // 上传头像
    async uploadAvatar(param) {
      // FormData 对象
      let form = new FormData();
      // 文件对象
      form.append("file", this.file);

      let { data } = await fileUpload(form);
      this.form.avatar = data.file.url || '';
    },
    // 修改
    async submitChange() {
      if (!this.code) {
        this.$message({
          message: '内容不能为空',
          type: "error"
        });
        return false;
      }

      await userApi.changeMobile({ code: this.code, mobile: this.ToastText })
      await this.$store.dispatch('user/GetUserInfo')
      this.editEoP = false;
      this.$message({
        message: res.data.msg,
        type: "success"
      });

    },
    // 获取验证码
    async getCode() {
      if (this.disabled) {
        return;
      }
      if (this.ToastText == "") {
        this.$message({
          message: "内容不能为空",
          type: "warning"
        });
        return;
      }

      await appApi.sendSms({ template_code: "user_mobile_modify",  mobile: this.ToastText });
      this.sendcode();
    },
    editPhone() {
      this.editEoP = true;
      this.ToastText = this.userInfo.mobile;
      this.time = 0;
      this.code = "";
    },
    // 获取用户信息
    getUserInfo() {
      this.form = {...this.userInfo};
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";

      if (!isJPG) {
        this.$message.error("检查图片格式");
      }
      return isJPG;
    },
    // 重置信息
    resetInfo() {
      this.getUserInfo()
    },
    // 保存资料
    async saveInfo() {
      await this.$store.dispatch('user/UpdateUserInfo', this.form)
      this.$message({
        message: '更新成功！',
        type: "success"
      });
      this.getUserInfo();
    },
    sendcode() {
      this.time = 60;
      this.timer();
    },
    //发送手机验证码倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        this.time--;
        this.btntxt = this.time + "秒";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "发送验证码";
        this.disabled = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/personal-info/personal-info.vue